var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatSendIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.574.491a.934.934 0 0 1 .897.083.88.88 0 0 1 .425.791v3.519c0 .22-.063.417-.188.59a.835.835 0 0 1-.52.33L9.339 7.506l6.849 1.7c.22.048.394.158.52.331.126.173.189.37.189.59v3.52c0 .346-.142.61-.426.79a.936.936 0 0 1-.897.083L1.027 8.38c-.394-.173-.59-.464-.59-.874s.196-.7.59-.874L15.574.491Z",
    fill: "#006CC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSendIcon);
export default __webpack_public_path__ + "static/media/chat_send_icon.ba5b16d5112d01bb1f1182ba25ba6cd2.svg";
export { ForwardRef as ReactComponent };